import api from './api';

// Favorites API calls
export const favoritesService = {
  // Get user's favorites
  getFavorites: async () => {
    const response = await api.get('/favorites');
    return response.data;
  },

  // Add property to favorites
  addFavorite: async (propertyId: string) => {
    const response = await api.post('/favorites', { propertyId });
    return response.data;
  },

  // Remove property from favorites
  removeFavorite: async (propertyId: string) => {
    const response = await api.delete(`/favorites/${propertyId}`);
    return response.data;
  },

  // Check if property is favorited
  checkFavorite: async (propertyId: string) => {
    const response = await api.get(`/favorites/check/${propertyId}`);
    return response.data;
  },
};

// Bookmarks API calls
export const bookmarksService = {
  // Get user's bookmarks
  getBookmarks: async () => {
    const response = await api.get('/bookmarks');
    return response.data;
  },

  // Add property to bookmarks
  addBookmark: async (propertyId: string) => {
    const response = await api.post('/bookmarks', { propertyId });
    return response.data;
  },

  // Remove property from bookmarks
  removeBookmark: async (propertyId: string) => {
    const response = await api.delete(`/bookmarks/${propertyId}`);
    return response.data;
  },

  // Check if property is bookmarked
  checkBookmark: async (propertyId: string) => {
    const response = await api.get(`/bookmarks/check/${propertyId}`);
    return response.data;
  },
};
